export const AUTHENTICATED: string = "authenticated";
export const CHANGE_BREADCRUMB: string = "changeBreadcrumb";
export const LOGGED_OUT: string = "loggedOut";
export const SWITCH_TO_TENANT: string = "switchToTenant";
export const ADD_COMMAND_BAR_ELEMENT: string = "addCommandBarElement";
export const REMOVE_COMMAND_BAR_ELEMENT: string = "removeCommandBarElement";
export const ENABLE_CANDIS_EMBEDDED_MODE: string = "enableCandisEmbeddedMode";
export const DISABLE_CANDIS_EMBEDDED_MODE: string = "disableCandisEmbeddedMode";
